if (!document.body.classList.contains('password')) {

  const setInputFocus = (event) => {
    if(event.shiftKey && event.key === 'Tab' || event.key === 'Tab') {
      event.target.classList.add('is-clicked');
    }
  }

  const removeInputFocus = (event) => {
    event.target.classList.remove('is-clicked');
  }

  document.body.addEventListener('click', (event) => {
    if(!event.target.closest('div[signup-modal]') && !event.target.matches('div[signup-modal]')) {
      const closeButton = document.querySelector('div[signup-modal] .klaviyo-close-form');
      closeButton?.click();
    }
  });

  window.addEventListener('klaviyoForms', (e) => {
    if (e.detail.formId == window.newsletter.modalId) {
      if (e.detail.type == 'open') {
        setCookie('hidden_klaviyo_modal', true, 5);
        setTimeout(() => {
          const formInput = document.querySelector('div[signup-modal] input[type="email"]');
          formInput?.addEventListener('keyup', (event) => setInputFocus(event));
          formInput?.addEventListener('focusout', (event) => removeInputFocus(event));
        }, 100)
      }
      if(e.detail.type == 'submit') {
        const closeButton = document.querySelector('div[signup-modal] .klaviyo-close-form');
        const klaviyoEmailForm = document.querySelector(`form[data-testid="klaviyo-form-${window.newsletter.modalId}"]`);
        klaviyoEmailForm.classList.add('email-submitted');

        if (closeButton) {
          setTimeout(() => {
            closeButton.click();
          }, 8000)
        }
      }
    }
  });

  const showModal = (delay) => {
    setTimeout((delay) => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', window.newsletter.modalId]);
    }, delay)
  }

  const cookieHiddenModal = getCookie('hidden_klaviyo_modal');

  window.addEventListener("PandectesEvent_OnHide", ()=> {
    if (cookieHiddenModal) {
      return
    }
    showModal(1000);
  })
}
